<template>
  <div class="relative">
    <div
      ref="scrollContainer"
      class="relative overflow-x-auto whitespace-nowrap touch-auto scrollbar-none"
      @scroll="onScroll"
    >
      <slot />
    </div>
    <slot
      name="custom-buttons"
      :scroll-forward="scrollForward"
      :scroll-back="scrollBack"
    >
      <vetster-carousel-buttons
        v-if="!isMobile()"
        class="lg:hidden flex justify-center mt-6"
        @next="scrollForward"
        @prev="scrollBack"
      />
    </slot>
  </div>
</template>

<script>
import VetsterCarouselButtons from '@/components/VetsterCarouselButtons';
import useDeviceHelpers from '@/composables/use-device-helpers';

export default {
  name: 'VetsterHorizontalScroll',

  components: { VetsterCarouselButtons },

  setup() {
    const { isMobile } = useDeviceHelpers();

    return { isMobile };
  },

  data() {
    return {
      scrollPosition: 0,
      scrollDistance: 220,
    };
  },

  methods: {
    scrollBack() {
      if (this.$refs.scrollContainer) {
        this.scrollPosition -= this.scrollDistance;
        this.$refs.scrollContainer.scrollLeft -= this.scrollDistance;
      }
    },
    scrollForward() {
      if (this.$refs.scrollContainer) {
        this.scrollPosition += this.scrollDistance;
        this.$refs.scrollContainer.scrollLeft += this.scrollDistance;
      }
    },
    onScroll(event) {
      this.scrollPosition = event.target.scrollLeft;
    },
  },
};
</script>
